export default __webpack_public_path__ + "static/media/bokchoy.20ecc2cd.svg";